import { config } from '../../config';
import { createStore } from '../_core/createStore';
import { pickState } from '../_core/pickState';
import { attributionStore, keysToPersist } from './attributionStore';

const useAttributionStore = createStore({
  creator: attributionStore({ config }),
  id: 'attribution',
  ignoreReset: true,
  middlewares: {
    devtools: true,
    persist: {
      partialize(state) {
        return pickState(state, keysToPersist);
      },
    },
  },
});

export default useAttributionStore;
